import { ref, watch, computed } from '@vue/composition-api'
import store from '@/store'

import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default function useBannerList() {
  // Use toast
  const toast = useToast()

  const refBannerTable = ref(null)

  // Table Handlers
  const tableColumns = [
    { key: 'id', sortable: true, label: '#' },
    { key: 'nome', sortable: true, label: 'Titulo' },
    { key: 'nome_tag', sortable: true, label: 'Tag' },
    { key: 'ativo', sortable: true, label: 'Status' },
    { key: 'data_inclusao', sortable: true, label: 'Data Criação' },
    { key: 'data_alteracao', sortable: true, label: 'Data Atualização' },
    { key: 'actions' },
  ]
  const perPage = ref(10)
  const totalUsers = ref(0)
  const currentPage = ref(1)
  const perPageOptions = [5, 10, 15, 20, 25, 50, 100]
  const searchQuery = ref('')
  const sortBy = ref('id')
  const isSortDirDesc = ref(true)
  const roleFilter = ref('')
  const grupoFilter = ref('')
  const statusFilter = ref('')

  const dataMeta = computed(() => {
    const localItemsCount = refBannerTable.value ? refBannerTable.value.localItems.length : 0
    return {
      from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
      to: perPage.value * (currentPage.value - 1) + localItemsCount,
      of: totalUsers.value,
    }
  })

  const refetchData = () => {
    refBannerTable.value.refresh()
  }

  watch([currentPage, perPage, searchQuery, roleFilter, grupoFilter, statusFilter], () => {
    refetchData()
  })

  const getStatus = status => {
    if (['1', 1, 'active', 'ativo', true, 'true'].indexOf(status) !== -1) {
      return 1
    }
    if (['0', 0, 'inactive', 'inativo', false, 'false'].indexOf(status) !== -1) {
      return 0
    }
    return null
  }

  const findAll = (ctx, callback) => {
    store
      .dispatch('Banners/findAll', {
        q: searchQuery.value,
        perPage: perPage.value,
        page: currentPage.value,
        sortBy: sortBy.value,
        sortDesc: isSortDirDesc.value,
        role: roleFilter.value,
        ativo: getStatus(statusFilter.value),
      })
      .then(response => {
        const { banners, total } = response.data

        callback(banners)
        totalUsers.value = total
      })
      .catch(() => {
        toast({
          component: ToastificationContent,
          props: {
            title: 'Error fetching banners list',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        })
      })
  }

  // *===============================================---*
  // *--------- UI ---------------------------------------*
  // *===============================================---*

  const resolveUserRoleVariant = role => {
    if (role === 'Admin B2B') return 'primary'
    if (role === 'Cliente B2B') return 'warning'
    if (role === 'Admin') return 'danger'
    return 'primary'
  }

  const resolveUserRoleIcon = role => {
    if (role === 'Cliente B2B') return 'UserIcon'
    if (role === 'Admin B2B') return 'SettingsIcon'
    if (role === 'Admin') return 'ServerIcon'
    return 'UserIcon'
  }

  const resolveUserStatusVariant = status => {
    if (status === 'pending') return 'warning'
    if (status === 1) return 'success'
    if (status === 0) return 'danger'
    return 'primary'
  }

  return {
    findAll,
    tableColumns,
    perPage,
    currentPage,
    totalUsers,
    dataMeta,
    perPageOptions,
    searchQuery,
    sortBy,
    isSortDirDesc,
    refBannerTable,

    resolveUserRoleVariant,
    resolveUserRoleIcon,
    resolveUserStatusVariant,
    refetchData,

    // Extra Filters
    roleFilter,
    grupoFilter,
    statusFilter,
  }
}
